import { Component, OnDestroy, OnInit } from '@angular/core';
import { RuntimeConfigService } from 'src/app/config/runtime-config.service';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
})
export class MaintenancePageComponent implements OnInit, OnDestroy {
  title = '';
  subtitle = '';
  eta = '';
  footer = '';

  private tickId: ReturnType<typeof setInterval> | null = null;

  constructor(private readonly runtimeConfigService: RuntimeConfigService) {}

  ngOnInit(): void {
    this.syncContent();
    this.tickId = setInterval(() => this.syncContent(), 60_000);
  }

  ngOnDestroy(): void {
    if (this.tickId) {
      clearInterval(this.tickId);
      this.tickId = null;
    }
  }

  private syncContent(): void {
    this.title = this.runtimeConfigService.maintenanceTitle;
    this.subtitle = this.runtimeConfigService.maintenanceSubtitle;
    this.footer = this.runtimeConfigService.maintenanceFooter;
    this.eta = this.buildEtaLabel();
  }

  private buildEtaLabel(): string {
    const etaIso = this.runtimeConfigService.maintenanceEtaIso;
    if (!etaIso) {
      return this.runtimeConfigService.maintenanceEtaText;
    }

    const etaDate = new Date(etaIso);
    if (Number.isNaN(etaDate.getTime())) {
      return this.runtimeConfigService.maintenanceEtaText;
    }

    const diffMs = etaDate.getTime() - Date.now();
    if (diffMs <= 0) {
      return 'Expected completion: any moment now';
    }

    const diffMinutes = Math.ceil(diffMs / 60_000);
    if (diffMinutes < 60) {
      return `Expected completion: ~${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
    }

    const diffHours = Math.ceil(diffMinutes / 60);
    return `Expected completion: ~${diffHours} hour${diffHours > 1 ? 's' : ''}`;
  }
}
